import React from 'react';
import { Button } from '@tremor/react';
import { useAuth } from '../../hooks/useAuth';

export default function Header() {
  const { user, logout } = useAuth();
  return (
    <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
      <span className="text-lg font-semibold text-gray-900">Agents</span>
      <div className="flex items-center gap-4">
        {user && <span className="text-sm text-gray-500">{user.email}</span>}
        <Button variant="secondary" size="xs" onClick={logout}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
